import {
    isExcludedScreen,
    isFreePlanUser,
    OLD_USERS_MIN_VISITS,
    type TSessionDialogContext,
    type TSessionDialogVerdict,
} from '@core/session-dialogs'

const VISITS_BETWEEN_SHOWS = 2

const shouldShowEverySecondVisit = (context: TSessionDialogContext): boolean => {
    const { oldUsersPromoShownAtVisit: shownAt, visitsCounter } = context

    if (shownAt === null) {
        if (!context.seenOldUsersPromo) {
            return true
        }

        context.writeOldUsersPromoShownAtVisit(visitsCounter - 1)

        return false
    }

    return visitsCounter - shownAt >= VISITS_BETWEEN_SHOWS
}

export const shouldShowOldUsersPromo = (context: TSessionDialogContext): TSessionDialogVerdict => {
    if (context.visitsCounter < OLD_USERS_MIN_VISITS) {
        return false
    }

    const isEligible = isFreePlanUser(context)

    if (isEligible !== true) {
        return isEligible
    }

    if (isExcludedScreen(context.screenId)) {
        return false
    }

    if (!context.lcpRecorded) {
        return 'pending'
    }

    return shouldShowEverySecondVisit(context)
}
